<template>
  <div>
    <v-card flat class="pa-1">
      <v-breadcrumbs class="systock-breadcrump" dark>
        <v-breadcrumbs-item>Configurações do menu de parametrização</v-breadcrumbs-item>
      </v-breadcrumbs>

      <v-tabs centered>
        <v-tab>
          <v-icon left>mdi-view-module</v-icon>
          Modulo
        </v-tab>

        <v-tab>
          <v-icon left>mdi-menu</v-icon>
          Menu
        </v-tab>

        <v-tab>
          <v-icon left>mdi-menu-open</v-icon>
          SubMenu
        </v-tab>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <Modulo />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <Menu />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <SubMenu />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import Modulo from "./Modulo/Index.vue";
import Menu from "./Menu/Index.vue";
import SubMenu from "./SubMenu/Index.vue";

export default {
  components: {
    Modulo,
    Menu,
    SubMenu
  }
}
</script>

<style>

</style>
